import "./App.css";
import GaugeChart from "react-gauge-chart";
import { useState } from "react";

function App() {
	const [inputText, setInputText] = useState<string>("");
	const [creditPercentage, setCreditPercentage] = useState<number>(0);
	const [creditMessage, setCreditMessage] = useState<string>("");
	const [animate, setAnimate] = useState(true);
	const [textColor, setTextColor] = useState("black");

	const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		setInputText(e.target.value);
		if (parseInt(e.target.value) >= 300 && parseInt(e.target.value) <= 850) {
			setCreditPercentage((parseInt(e.target.value) - 300) / 550);
			setTimeout(() => {
				setAnimate(false);
				setCreditMessage(findScoreRating(parseInt(e.target.value)));
			}, 3000);
			setAnimate(true);
		} else {
			setCreditPercentage(0);
			setCreditMessage("");
		}
	};

	const findScoreRating = (inputScore: number) => {
		if (inputScore <= 560) {
			setTextColor("red");
			return `Very bad`;
		} else if (inputScore <= 650) {
			setTextColor("orange");
			return `Bad`;
		} else if (inputScore <= 700) {
			setTextColor("yellow");
			return `Fair`;
		} else if (inputScore <= 750) {
			setTextColor("green");
			return `Good`;
		} else if (inputScore <= 850) {
			setTextColor("green");
			return `Excellent`;
		} else {
			setTextColor("black");
			return "";
		}
	};

	return (
		<div
			className="App"
			style={{
				width: "100%",
				display: "flex",
				flexDirection: "row",
				justifyContent: "center",
			}}
		>
			<div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
				<input
					className="credit-score-input"
					placeholder="Enter Credit Score"
					type="text"
					value={inputText}
					onChange={onChangeInput}
				/>
				<GaugeChart
					style={{
						width: "100%",
						maxWidth: "600px",
						maxHeight: "270px",
					}}
					id="gauge-chart1"
					arcsLength={[260, 90, 50, 150]}
					colors={["red", "orange", "yellow", "green"]}
					arcWidth={0.25}
					arcPadding={0}
					cornerRadius={0}
					needleBaseColor="#CCCCCC"
					needleColor="#CCCCCC"
					animate={animate}
					animDelay={0}
					animateDuration={4000}
					formatTextValue={() => ""}
					percent={creditPercentage}
				/>
				<div style={{ height: "60px" }}>
					<span style={{ color: textColor, fontSize: "3rem" }}>{creditMessage}</span>
				</div>
			</div>
			<style>
				{`
					.text-group {
            color: red
					}
          .credit-score-input {
            width:60%;
            max-width:360px;
            padding:10px;
            margin:20px 0;
            border:1px solid #CCCCCC;
            box-shadow:0 0 15px 4px rgba(0,0,0,0.1);
            border-radius:25px;
            text-align: center;
            font-size: 20px;
          }
          :focus-visible {
            outline: #CCCCCC auto 1px
          }
        `}
			</style>
		</div>
	);
}

export default App;
